import {RootStore} from "./rootStore";
import {action, observable, makeObservable, runInAction} from "mobx";

export default class WallSettingsStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    makeObservable(this, {
      subjectType: observable,
      setSubjectType: action
    });
  }

  subjectType = 'subject';

  setSubjectType = (type:string) => {
    runInAction(() => {
      switch(type) {
        case "/curriculum/subjects":
          this.subjectType = "subject";
          break;
        case "/curriculum/specialist-modules":
          this.subjectType = "specialistModule";
          break;
        case "/curriculum/co-curricular":
          this.subjectType = "co-curricular";
      }
    });
  }
}
